import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { I18N_NAMESPACES, TOP_UP_VALUES } from "../../../helpers/constants";

import AddToBoxOrCartButton from "../AddToBoxOrCartButton";
import CellarBtnCta from "../../atoms/CellarBtnCta";
import { GET_WINE_NAME_AND_LARGE_PHOTO } from "../../../graphql/resolvers/wine";
import { GetWinePhotos_wine } from "../../../types/__generated__/GetWinePhotos";
import { GetLatestVintage_latestVintage } from "../../../types/__generated__/GetLatestVintage";
import { useAppContext } from "../../organisms/Layout/context";
import TopUpTrayV2 from "../../organisms/TopUpTrayV2";

interface BuyAgainButtonsProps {
  isInBoxAndCartTray?: boolean;
  wine: GetWinePhotos_wine | GetLatestVintage_latestVintage;
  baseColor: string;
  bottleImage: string;
}

const BuyAgainButtons = ({ isInBoxAndCartTray, wine, baseColor, bottleImage }: BuyAgainButtonsProps) => {
  const { t } = useTranslation([I18N_NAMESPACES.MY_CELLAR]);
  const [isOffCanvasTopUpOpened, setIsOffCanvasTopUpOpened] = useState(false);
  const [topUpWineQuantity, setTopUpWineQuantity] = useState(0);
  const { memberId } = useAppContext();

  const handleOffCanvasTopUpChange = (quantity?: number) => {
    setIsOffCanvasTopUpOpened(!isOffCanvasTopUpOpened);
    quantity && setTopUpWineQuantity(quantity);
  };

  const commonAddToBoxOrCartButtonProps = {
    showTray: false,
    wine,
    extraRefetchQueries: [
      {
        query: GET_WINE_NAME_AND_LARGE_PHOTO,
        variables: { slug: wine.product?.slug, memberId },
      },
    ],
    ButtonComponent: CellarBtnCta,
    submittingLabel: t("myCellar:adding"),
  };

  return (
    <>
      <AddToBoxOrCartButton
        {...commonAddToBoxOrCartButtonProps}
        forceAddToBox
        label={t("myCellar:addToMyNextBox")}
      />
      <AddToBoxOrCartButton
        {...commonAddToBoxOrCartButtonProps}
        forceAddToCart
        label={t("myCellar:addToMyOneOffCart")}
      />

      {memberId && isOffCanvasTopUpOpened && (
        <TopUpTrayV2
          memberId={memberId}
          handleOffCanvasTopUpClose={handleOffCanvasTopUpChange}
          isInBoxAndCartTray={isInBoxAndCartTray}
          wine={wine}
          baseColor={baseColor}
          bottleImage={bottleImage}
          topUpWineQuantity={topUpWineQuantity}
        />
      )}
      {TOP_UP_VALUES.map((topUpValue) => {
        const hasStockForTopUpValue =
          wine[`hasStock${topUpValue}` as keyof (GetWinePhotos_wine | GetLatestVintage_latestVintage)];
        return (
          <CellarBtnCta
            onClick={() => handleOffCanvasTopUpChange(topUpValue)}
            disabled={!hasStockForTopUpValue}
            key={topUpValue}
          >
            {t("common:bottlesTopup", { count: topUpValue })} (
            {hasStockForTopUpValue ? t("myCellar:topupDiscount") : t("myCellar:notEnoughStock")})
          </CellarBtnCta>
        );
      })}
    </>
  );
};

export default BuyAgainButtons;
